/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/*
// Author: Grin Zhou
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FormattedHTMLMessage } from 'react-intl';
import { HTMLDecode, loadLanguage } from '../../utils';
import './QuestionMark.css';

export default class QuestionMark extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showHints: props.showHints
    };

    [
      'hintsHandler'
    ].forEach((fn) => this[fn] = this[fn].bind(this));

    this.setupData(props);
  }

  hintsHandler = (event)=> {
    /*
    * handle hints show or hidden.
    */

    event.stopPropagation && event.stopPropagation();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.preventDefault();

    this.setState({showHints: !this.state.showHints});
    return false;
  };

  setupData(props) {
    /*
    * setup component required props.
    */
    const that = this;
    React.Children.map(props.children, function(item) {
      if (item.type==='hints') that.hintsData = item.props;
    });
  };

  componentWillReceiveProps(nextProps) {
    this.setupData(nextProps)
  }
  handleMouseOver = () => {
    this.setState({showHints: true});
  }
  handleMouseOut = () => {
    this.setState({showHints: false});
  }
  ariaLabelTip = () => {
    if (loadLanguage() === 'zh-CN') {
      return '帮助工具提示 '
    } else {
      return 'Help tooltip for '
    }
  }
  render() {
    const hintsClz = this.state.showHints ? 'on' : '';
    return (
      <div className={ `question-mark ${hintsClz}` }
        onMouseOver={this.handleMouseOver}
        onMouseOut={this.handleMouseOut}
      >
        <Button
          bsStyle="link"
          onClick={ this.hintsHandler }
          role={ 'button' }
          aria-label={ this.ariaLabelTip() + this.props.questionTitle }
          aria-describedby={ `${this.hintsData.dataKey}_questionMarkContainer` }
        >
          <i aria-hidden={true} className="icon" />
        </Button>

        <div
          role="tooltip"
          aria-expanded={ this.state.showHints }
          aria-label={ HTMLDecode(this.hintsData.children) }
          className="hints"
          data-key={ this.hintsData.dataKey }
          id={ this.hintsData.dataKey+"_questionMarkContainer" }
        >
          <FormattedHTMLMessage
            id={ this.hintsData.dataKey+"_questionMarkInfo" }
            defaultMessage={ this.hintsData.children }
          />
        </div>
      </div>
    )
  }
};

QuestionMark.propTypes = {
  showHints: PropTypes.bool,
  questionTitle: PropTypes.string,
};
QuestionMark.defaultProps = {
  showHints: false,
  questionTitle: 'Question Mark Button'
};


// WEBPACK FOOTER //
// ./src/shared/QuestionMark/index.js